export function detectConvertedValue<T>(value: T): T | null {
  if (typeof value === 'string' && value === 'no-matter') {
    return null;
  }

  return value;
}
